<template>
  <div class="container">
    <van-tabs v-model="activeTabIndex" sticky>
      <van-tab title="健康问卷">
        <div class="survey-wrapper">
          <div class="survey-list">
            <!-- <div class="survey-item" v-for="survey in surveyList">
              <div class="survey-info">
                <div class="survey-icon">
                  <img src="@/assets/images/icon-survey-edit.png" />
                </div>
                <h3 @click="onSurveyClicked(survey.id)" style="text-align:center">{{survey.name}}</h3>
                <p>
                  <van-button type="default" size="small" round @click="onSurveyClicked(survey.id)">填写问卷</van-button>
                </p>
                <div>
                </div>
              </div>
            </div> -->
            <div v-for="survey in surveyList" class="survey-item-wrap"
              :class="survey.survey_type == 0?'survey-bg-0':'survey-bg-1'" @click="onSurveyClicked(survey.id)">
              <div style="height:120px;border-radius:10px 10px 0 0;"></div>
              <div class="survey-item-title">{{survey.name}}</div>
            </div>
          </div>
        </div>
      </van-tab>
      <van-tab title="我的记录">
        <div class="record-wrapper">
          <div class="user-survey-list">
            <div class="user-survey-wrap" v-for="(sur,index) in userSurveyList">
              <div class="user-survey-title">
                {{sur.survey_name}}
              </div>
              <div class="user-survey-item">
                <div class="survey-icon">
                  <img src="@/assets/images/icon-survey-ok.png" />
                </div>
                <div class="survey-info" @click="showDetail(sur.id)">
                  <h3>{{sur.name}}</h3>
                  <p>
                    <span class="item-title">填写时间：{{sur.create_time|dateFormat()}}</span>
                  </p>
                  <div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-tab>
    </van-tabs>

    <van-popup v-model="showProfile" round closeable position="bottom" :style="{ height: '80%' }">
      <h3 class="popup-header">请选择问卷评估人员</h3>
      <div>
        <profileList @select="selectProfile" />
      </div>
    </van-popup>
  </div>
</template>

<style lang="less" scoped>
  .container {
    background: #f3f3f3;
  }

  .survey-wrapper {
    padding: 24px;

    .survey-list {
      .survey-item {
        margin-bottom: 24px;
        background: #ffffff;
        border-radius: 5px;

        .survey-info {
          padding: 16px;

          p {
            font-size: 13px;
            color: rgba(0, 0, 0, 0.8);
            line-height: 32px;

          }
        }

        text-align: center;

        .survey-icon {
          text-align: center;

          img {
            width: 48px;
            height: 48px;
          }
        }

        h3 {
          line-height: 40px;
        }
      }

      .survey-item-wrap {
        height: 150px;
        background-image: url("../../assets/images/img-survey-1.jpg");
        background-size: cover;
        border-radius: 10px;
        box-shadow: 0px 0px 10px 1px rgb(228, 228, 228);
        margin-bottom: 24px;

        .survey-item-title {
          padding: 0 16px;
          line-height: 30px;
          background-color: rgba(0, 0, 0, 0.6);

          color: #ffffff;
          border-radius: 0 0 10px 10px;
        }
      }

      .survey-bg-0 {
        background-image: url("../../assets/images/img-survey-0.jpg");
      }

      .survey-bg-1 {
        background-image: url("../../assets/images/img-survey-1.jpg");
      }
    }
  }

  .record-wrapper {
    padding: 24px;

    .user-survey-list {
      .user-survey-wrap {
        margin-bottom: 24px;
        background: #ffffff;
        border-radius: 5px;
        padding: 16px;

        .user-survey-title {
          font-size: 18px;
          padding: 0 10px 8px 10px;
          // border-bottom: 1px solid rgb(228, 228, 228);
        }

        .user-survey-item {
          display: flex;

          .survey-icon {
            text-align: center;
            margin-right: 16px;

            img {
              padding: 8px;
              width: 48px;
              height: 48px;
            }
          }

          h3 {
            text-align: left;
            line-height: 40px;
          }

          .survey-info {
            p {
              font-size: 13px;
              color: rgba(0, 0, 0, 0.8);
            }
          }

        }
      }
    }
  }

  .popup-header {
    padding: 16px 20px 0 20px;
  }
</style>

<script>
  import profileList from "@/components/profileList";
  import * as survey_api from '@/api/survey.js';
  import {
    mapState,
    mapMutations,
    mapActions
  } from 'vuex'
  export default {
    components: {
      profileList
    },
    data() {
      return {
        surveyInfo: Object,
        surveyList: [],
        userSurveyList: [],
        activeTabIndex: 0,
        showProfile: false,
        surveyId: 0,
      };
    },
    mounted() {
      let hospid = this.$route.query.hospid;
      survey_api.getSurveyInfo(hospid).then(res => {
        console.log(res);
        if (res.code == 200) {
          this.surveyList = res.data;
        }
      })
      this.getUserSurveys();
    },
    methods: {
      ...mapActions(
        "user", {
          setActiveUserProfile: "setActiveUserProfile"
        }
      ),
      onSurveyClicked(id) {
        this.surveyId = id;
        this.showProfile = true;
      },
      selectProfile(profile) {
        console.log(profile);
        this.showProfile = false;
        this.setActiveUserProfile(profile);
        this.$router.push({
          path: "survey/fill",
          query: {
            surveyId: this.surveyId
          }
        });
      },
      getUserSurveys() {
        survey_api.getUserSurveys().then(res => {
          this.userSurveyList = res.data;
        });
      },
      showDetail(id) {
        this.$router.push({
          path: "/survey/detail",
          query: {
            id: id
          }
        });
      }
    }
  }
</script>